<template>
  <section class="section" v-touch:swipe.left="swipeLeftHandler">
    <div class="text text--font">
      <p>Из года в год рождается миллион обсуждений вокруг рейтингов Tagline. Каждый, кто считает себя экспертом, в этом году имеет возможность помериться силой с себе подобными.</p>
      <p>Участвуй в digital-тотализаторе, делай ставки и узнай, кто ты – старожил рынка или молокосос.</p>
      <p class="bold">Ставки сделаны. Ставок больше нет. Поздравляем победителей.</p>
    </div>
    <div class="btn-group">
      <router-link class="btn btn--green" to="/statistics">Исходы →</router-link>
      <router-link class="btn btn--green" to="/rating">Рейтинг →</router-link>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    swipeLeftHandler() {
      this.$router.push('/statistics');
    },
  },
};
</script>
